export const EMLIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.2002 3.2C3.2002 1.43269 4.63288 0 6.4002 0H19.2002L28.8002 9.6V28.8C28.8002 30.5673 27.3675 32 25.6002 32H6.4002C4.63289 32 3.2002 30.5673 3.2002 28.8V3.2Z"
        fill="#444CE7"
      />
      <path opacity="0.3" d="M19.2002 0L28.8002 9.6H22.4002C20.6329 9.6 19.2002 8.16731 19.2002 6.4V0Z" fill="white" />
      <path
        d="M8.91429 25.3984V20.1621H12.4427V21.0749H10.0214V22.3226H12.2612V23.2354H10.0214V24.4857H12.4529V25.3984H8.91429ZM13.3229 20.1621H14.6882L16.1303 23.6803H16.1916L17.6337 20.1621H18.999V25.3984H17.9252V21.9902H17.8817L16.5266 25.3729H15.7953L14.4402 21.9774H14.3968V25.3984H13.3229V20.1621ZM19.9112 25.3984V20.1621H21.0183V24.4857H23.2632V25.3984H19.9112Z"
        fill="white"
      />
    </svg>
  );
};
